import { InputMask } from './types'

// Mirrors TextInput's historical `format='float'` behavior byte-for-byte:
// anything `Number(...)` considers finite is accepted (quirk: that includes
// scientific notation like `1e3`), and blur collapses to the numeric form.
export const floatFormat: InputMask = {
  sanitize: (input) => (Number.isFinite(Number(input)) ? input : null),
  format: (raw) => raw,
  normalizeOnBlur: (raw) => String(Number(raw)),
  placeholder: '0.0',
}
